import React from "react";
import { fmtErr } from "../lib/api";
import { Button } from "./ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";

// Dashboard placeholder: a spinner while loading, or the error with a Retry button (never "Loading…" forever).
export default function DashLoading({ error, onRetry, testid }) {
  if (error) {
    return (
      <div className="max-w-md mx-auto mt-10 rounded-xl border border-red-200 bg-red-50 p-5 text-center" data-testid={testid ? `${testid}-error` : undefined}>
        <AlertTriangle className="w-8 h-8 text-red-600 mx-auto" />
        <p className="mt-2 font-semibold text-red-800">Could not load the dashboard</p>
        <p className="text-sm text-red-700 mt-1">{fmtErr(error)}</p>
        <Button onClick={onRetry} className="mt-4 bg-maroon-700 hover:bg-maroon-800 text-white"><RefreshCw className="w-4 h-4 mr-1" /> Retry</Button>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-3 text-sm text-slate-500 mt-6" data-testid={testid}>
      <div className="w-5 h-5 border-2 border-gold-400 border-t-maroon-700 rounded-full animate-spin" /> Loading dashboard…
    </div>
  );
}
